import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import {
  receiptsViewInit,
  receiptsViewOnFetchReceiptsRequest,
} from '../receiptsViewSlice';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof receiptsViewInit>;
type OUT = ReturnType<typeof receiptsViewOnFetchReceiptsRequest>;

export const ReceiptsViewInitEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(receiptsViewInit.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [receiptsViewOnFetchReceiptsRequest()];
    }),
  );
